import { render } from "./TarotInfoComponent.vue?vue&type=template&id=4b0cc61e&scoped=true"
import script from "./TarotInfoComponent.vue?vue&type=script&lang=js"
export * from "./TarotInfoComponent.vue?vue&type=script&lang=js"

import "./TarotInfoComponent.vue?vue&type=style&index=0&id=4b0cc61e&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b0cc61e"]])

export default __exports__